<template>
  <div class="column-12 laptop:column-2 order-last laptop:order-first tablet:display-flex laptop:display-block">
    <div
      style="flex: 1 0 0"
      class="tablet:margin-top-3xl"
    >
      <font-awesome-icon
        :icon="$v6.solid.faCircleQuestion"
        size="xl"
        class="decorative"
        style="color: var(--fa-md-gravy)"
      />
      <h4 class="margin-top-md margin-bottom-2xs">Support</h4>
      <p>Have a question about our plans?</p>
      <p>
        <a
          href="mailto:hello@fontawesome.com?subject=I've got a question about plans, Font Awesome!"
          @click="supportLinkClicked('plans_view', 'card_section')"
          >Get in touch!</a
        >
      </p>
    </div>
    <div
      style="flex: 1 0 0"
      class="margin-top-3xl"
    >
      <font-awesome-icon
        :icon="$v6.solid.faRocketLaunch"
        size="xl"
        class="decorative"
        style="color: var(--fa-md-gravy)"
      />
      <h4 class="margin-top-md margin-bottom-2xs">Start for Free</h4>
      <p>Want to give Font Awesome a try?</p>
      <p><site-link :to="{ name: 'start' }">Grab a Free account!</site-link></p>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'PlansSupplementaryInfoSection'
  }
</script>
